/* PriconMed pack for Athens 6.7 — storefront behaviour.
 * Loaded (defer) from snippets/pm-body-end.liquid, after Athens scripts.js / pubsub.js.
 * No dependencies. Everything is progressive enhancement: pages work without JS.
 */
(function () {
  'use strict';

  var CFG = window.pmConfig || {};
  var PM = (window.PM = window.PM || {});

  /* ------------------------------------------------------------------ utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(window.localStorage.getItem(key));
      if (val === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
    return null;
  }
  function money(cents) {
    var n = Number(cents) / 100;
    try { return n.toLocaleString('en-US', { style: 'currency', currency: CFG.currency || 'USD' }); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function normalizeMpn(v) { return String(v || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase(); }
  PM.normalizeMpn = normalizeMpn;

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pm-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }
  PM.toast = toast;

  /* ------------------------------------------- shipping cutoff (3 PM CT M–F) */
  var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function nowInTz(tz) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') parts[p.type] = p.value; });
    var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      hour: parseInt(parts.hour, 10) % 24,
      minute: parseInt(parts.minute, 10),
      second: parseInt(parts.second, 10),
      weekday: map[parts.weekday] != null ? map[parts.weekday] : new Date().getDay()
    };
  }
  function cutoffStatus() {
    var tz = CFG.cutoffTz || 'America/Chicago';
    var cutoffH = CFG.cutoffHour != null ? Number(CFG.cutoffHour) : 15;
    var n = nowInTz(tz);
    var weekend = n.weekday === 0 || n.weekday === 6;
    var secs = cutoffH * 3600 - (n.hour * 3600 + n.minute * 60 + n.second);
    if (!weekend && secs > 0) {
      var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
      var t = h > 0 ? h + 'h ' + m + 'm' : m > 0 ? m + 'm ' + s + 's' : s + 's';
      return { today: true, message: 'Order in the next ' + t + ' for same-day handling', short: 'Ships today' };
    }
    var next = (n.weekday + 1) % 7;
    while (next === 0 || next === 6) next = (next + 1) % 7;
    return { today: false, message: 'Order today, ships ' + WEEKDAYS[next], short: 'Ships ' + WEEKDAYS[next].slice(0, 3) };
  }
  PM.cutoffStatus = cutoffStatus;

  var ICON_CLOCK = '<svg class="pm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
  var ICON_TRUCK = '<svg class="pm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';

  function paintCutoff(el) {
    var st = cutoffStatus();
    var variant = el.getAttribute('data-pm-cutoff') || 'full';
    el.classList.add('pm-cutoff');
    el.classList.toggle('pm-cutoff--today', st.today);
    el.innerHTML = (st.today ? ICON_CLOCK : ICON_TRUCK) + '<span>' + esc(variant === 'badge' ? st.short : st.message) + '</span>';
  }
  function paintAllCutoffs() { $all('[data-pm-cutoff]').forEach(paintCutoff); }
  PM.paintAllCutoffs = paintAllCutoffs;

  /* ----------------------------------------- Athens-compatible add to cart */
  function uniqueSections(list) {
    if (typeof window.getUniqueSectionNames === 'function') return window.getUniqueSectionNames(list);
    var seen = {};
    return list.map(function (s) { return s.section; }).filter(function (n) { if (!n || seen[n]) return false; seen[n] = 1; return true; });
  }
  // opts.quiet: refresh the drawer but do not open it or redirect (batch callers open once at the end).
  function addToCart(items, opener, context, opts) {
    opts = opts || {};
    var miniCart = window.miniCart || document.querySelector('mini-cart');
    var sections = [];
    try { if (miniCart && miniCart.getSectionsToRender) sections = uniqueSections(miniCart.getSectionsToRender()); } catch (e) { sections = []; }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    }).then(function (res) { return res.json(); }).then(function (data) {
      if (data.status) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartError, { source: context || 'pm', errors: data.errors || data.description, message: data.message });
        }
        if (miniCart && miniCart.updateSectionContents) miniCart.updateSectionContents();
        throw new Error(data.description || data.message || 'Could not add to cart');
      }
      var added = data.items || [data];
      if (miniCart && miniCart.renderContents && data.sections) {
        try { miniCart.renderContents(data); } catch (e) { if (miniCart.updateSectionContents) miniCart.updateSectionContents(); }
      } else if (miniCart && miniCart.updateSectionContents) {
        miniCart.updateSectionContents();
      }
      if (!opts.quiet) openCartAfterAdd(opener);
      document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: added, context: context || 'pm' } }));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartItemAdd, { source: context || 'pm', items: added });
      }
      return data;
    });
  }
  function openCartAfterAdd(opener) {
    var miniCart = window.miniCart || document.querySelector('mini-cart');
    if (!miniCart || (window.themeSettings && window.themeSettings.redirectToCart)) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    } else if (miniCart.open) {
      miniCart.open(opener || null);
    } else {
      document.dispatchEvent(new CustomEvent('open-mini-cart', { detail: { opener: opener || null } }));
    }
  }
  PM.openCart = openCartAfterAdd;
  PM.addToCart = addToCart;
  window.pmAddToCart = addToCart;

  // Generic buttons: <button data-pm-add="variantId" data-pm-qty="1">
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pm-add]');
    if (!btn) return;
    e.preventDefault();
    var id = Number(btn.getAttribute('data-pm-add'));
    var qty = Number(btn.getAttribute('data-pm-qty') || 1);
    if (!id) return;
    btn.setAttribute('aria-disabled', 'true');
    addToCart([{ id: id, quantity: qty }], btn, 'PmButton')
      .catch(function (err) { toast(err.message); })
      .then(function () { btn.removeAttribute('aria-disabled'); });
  });

  /* ----------------------------- mini cart: MPN per line + cutoff in footer */
  var skuCache = {}, skuFetch = null;
  function enhanceMiniCart() {
    var content = document.getElementById('header-mini-cart-content');
    var footer = document.getElementById('header-mini-cart-footer');
    if (footer && CFG.cartCutoff !== false && !footer.querySelector('[data-pm-cutoff]')) {
      var el = document.createElement('div');
      el.className = 'pm-mini-cutoff';
      el.setAttribute('data-pm-cutoff', 'full');
      footer.insertBefore(el, footer.firstChild);
      paintCutoff(el);
    }
    if (!content || CFG.cartSku === false) return;
    var lines = $all('.js-cart-item[data-variant-id]', content).filter(function (l) { return !l.querySelector('.pm-cart-sku'); });
    if (!lines.length) return;
    var need = lines.some(function (l) { return !(l.getAttribute('data-variant-id') in skuCache); });
    if (need && !skuFetch) {
      skuFetch = fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { (cart.items || []).forEach(function (it) { skuCache[String(it.variant_id)] = it.sku || ''; }); })
        .catch(function () {})
        .then(function () { skuFetch = null; lines.forEach(function (l) { var id = l.getAttribute('data-variant-id'); if (!(id in skuCache)) skuCache[id] = ''; }); });
    }
    (skuFetch || Promise.resolve()).then(function () {
      lines.forEach(function (l) {
        var sku = skuCache[l.getAttribute('data-variant-id')];
        var heading = l.querySelector('.mini-cart-item-heading');
        if (!sku || !heading || l.querySelector('.pm-cart-sku')) return;
        var s = document.createElement('span');
        s.className = 'pm-cart-sku';
        s.textContent = 'MPN: ' + sku;
        heading.insertAdjacentElement('afterend', s);
      });
    });
  }
  function watchMiniCart() {
    var target = document.querySelector('mini-cart') || document.getElementById('HeaderMiniCart');
    if (!target) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; enhanceMiniCart(); });
    }).observe(target, { childList: true, subtree: true });
    document.addEventListener('mini-cart:opened', enhanceMiniCart);
    enhanceMiniCart();
  }

  /* --------------------------------------------- conversational query test */
  var QUESTION_START_RE = /^(what|whats|what's|which|how|why|when|where|who|can|could|would|should|do|does|did|is|are|will|may|any)\b/;
  var INTENT_RE = new RegExp([
    '\\blooking for\\b', '\\bi (need|want|would like|am looking)\\b', '\\bneed (a|an|some|help|advice|suggestions?|recommendations?)\\b',
    '\\bhelp me\\b', '\\brecommend(ation)?s?\\b', '\\bsuggest(ion)?s?\\b', '\\bsomething (for|to|that)\\b', '\\banything (for|to|that)\\b',
    '\\bbest (for|to|way)\\b', '\\bbest \\w+(?: \\w+)? for\\b', '\\bgood (for|to)\\b', '\\bgood \\w+(?: \\w+)? for\\b',
    '\\balternatives? to\\b', '\\bequivalent (to|of)\\b', '\\bsubstitute for\\b', '\\binstead of\\b', '\\bcompatible with\\b',
    '\\bwork(s)? with\\b', '\\bfit(s)? (a|an|the|my|our)\\b', '\\bdifference between\\b', '\\bcompared to\\b', '\\bvs\\.?\\b',
    '\\bversus\\b', '\\bfor (a|an|my|our) (patient|clinic|practice|office|spa|hospital)\\b',
    '\\bfor (elderly|kids?|children|infants?|babies|adults?|seniors?|pediatric|geriatric)\\b', '\\bfor sensitive\\b',
    '\\bfor use (with|on|in)\\b', '\\bhow (do|can|should) (i|you|we)\\b', '\\bcan (i|you|we)\\b', '\\bhelp (with|me|us)\\b'
  ].join('|'), 'i');
  var SKU_TOKEN_RE = /^(?=.*\d)[a-z0-9][a-z0-9\-\/.]{2,}$/i;
  function isConversational(input) {
    var raw = String(input || '').trim();
    if (!raw) return false;
    var cleaned = raw.replace(/[.,!;:"'()\[\]]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    var words = cleaned.split(' ').filter(Boolean);
    var q = /\?/.test(raw);
    if (words.length <= 2 && !q) return false;
    if (words.some(function (w) { return SKU_TOKEN_RE.test(w); }) && !q) return false;
    if (q) return true;
    if (words.length >= 3 && QUESTION_START_RE.test(cleaned)) return true;
    if (INTENT_RE.test(cleaned)) return true;
    return words.length >= 6;
  }
  PM.isConversational = isConversational;

  /* Hero / inline search forms: route questions to the AI concierge when enabled. */
  function initPlaceholders() {
    var mq = window.matchMedia('(max-width: 767px)');
    function apply() {
      $all('[data-pm-placeholder-mobile]').forEach(function (el) {
        if (!el.getAttribute('data-pm-placeholder-desktop')) el.setAttribute('data-pm-placeholder-desktop', el.getAttribute('placeholder') || '');
        var m = el.getAttribute('data-pm-placeholder-mobile');
        el.setAttribute('placeholder', mq.matches && m ? m : el.getAttribute('data-pm-placeholder-desktop'));
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }
  function initSearchForms() {
    $all('form[data-pm-search]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[name="q"]');
        var q = input ? input.value.trim() : '';
        if (!q) { e.preventDefault(); if (input) input.focus(); return; }
        var concierge = document.querySelector('[data-pm-ai]');
        if (CFG.aiEnabled && concierge && isConversational(q)) {
          e.preventDefault();
          concierge.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (concierge.pmAsk) concierge.pmAsk(q);
        }
      });
    });
  }

  /* --------------------------------------------------------- AI concierge */
  function initConcierge(root) {
    var input = root.querySelector('[data-pm-ai-input]');
    var form = root.querySelector('[data-pm-ai-form]');
    var out = root.querySelector('[data-pm-ai-result]');
    var endpoint = root.getAttribute('data-endpoint');
    var key = root.getAttribute('data-key');
    var LAST = 'priconmed-last-ai-prompt';

    $all('[data-pm-ai-tab]', root).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-pm-ai-tab');
        $all('[data-pm-ai-tab]', root).forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        $all('[data-pm-ai-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-pm-ai-panel') !== id; });
      });
    });
    $all('[data-pm-ai-prompt]', root).forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.textContent.trim(); input.focus(); });
    });
    var last = store(LAST);
    if (last && typeof last === 'object') last = last.prompt || '';
    var ctrl = null, reqId = 0;
    var cont = root.querySelector('[data-pm-ai-continue]');
    if (last && cont) {
      cont.hidden = false;
      cont.querySelector('[data-pm-ai-last]').textContent = last;
      cont.querySelector('[data-pm-ai-resume]').addEventListener('click', function () { input.value = last; ask(last); });
      cont.querySelector('[data-pm-ai-clear]').addEventListener('click', function () { store(LAST, null); cont.hidden = true; });
    }

    function card(p) {
      var url = (window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') : '') + '/products/' + encodeURIComponent(p.handle);
      return '<li class="pm-ai__item"><a href="' + esc(url) + '" style="display:flex;gap:12px;text-decoration:none;color:inherit;background:#fff;border:1px solid var(--pm-border);border-radius:8px;padding:10px">' +
        (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64" style="width:64px;height:64px;object-fit:contain;flex:none" loading="lazy">' : '') +
        '<span style="min-width:0"><small style="color:var(--pm-primary);font-weight:600">' + esc(p.vendor || '') + '</small><strong style="display:block;font-size:14px;line-height:19px">' + esc(p.title) + '</strong>' +
        (p.price ? '<span style="font-weight:700">' + esc(money(Math.round(Number(p.price) * 100))) + '</span>' : '') +
        (p.reason ? '<span style="display:block;font-size:12px;color:var(--pm-muted-fg);margin-top:2px">' + esc(p.reason) + '</span>' : '') +
        '</span></a></li>';
    }

    function ask(q) {
      q = String(q || '').trim();
      if (!q) return;
      store(LAST, q);
      var searchUrl = ((window.routes && window.routes.search_url) || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
      if (!endpoint) { window.location.href = searchUrl; return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var my = ++reqId;
      out.hidden = false;
      out.setAttribute('aria-busy', 'true');
      out.innerHTML = '<p class="pm-ai__note">Searching the catalog…</p>';
      var interp = '', results = [], candidates = [];
      function paint(done) {
        if (my !== reqId) return;
        if (done) out.removeAttribute('aria-busy');
        var list = results.length ? results : candidates;
        out.innerHTML =
          (interp ? '<div class="pm-ai__answer">' + esc(interp) + '</div>' : '') +
          (list.length ? '<ul style="list-style:none;padding:0;margin:12px 0 0;display:grid;gap:8px;grid-template-columns:repeat(auto-fill,minmax(260px,1fr))">' + list.map(card).join('') + '</ul>' : (done ? '<p class="pm-ai__note">No matching products found. <a class="pm-link" href="' + esc(searchUrl) + '">Search normally</a></p>' : '')) +
          '<p class="pm-ai__note">Suggestions only — verify product suitability before ordering. <a class="pm-link" href="' + esc(searchUrl) + '">See all results for “' + esc(q) + '”</a></p>';
      }
      var headers = { 'Content-Type': 'application/json' };
      if (key) { headers.Authorization = 'Bearer ' + key; headers.apikey = key; }
      fetch(endpoint, { method: 'POST', headers: headers, body: JSON.stringify({ query: q }), signal: ctrl ? ctrl.signal : undefined }).then(function (res) {
        if (my !== reqId) return;
        if (!res.ok || !res.body) { window.location.href = searchUrl; return; }
        var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
        function handle(line) {
          var ev; try { ev = JSON.parse(line); } catch (e) { return; }
          if (ev.type === 'interpretation') interp = ev.text || '';
          else if (ev.type === 'candidates') candidates = ev.results || [];
          else if (ev.type === 'result' && ev.result) results.push(ev.result);
          else if (ev.type === 'error') interp = 'AI search is unavailable right now.';
          else if (ev.type === 'done') paint(true);
        }
        function pump() {
          if (my !== reqId) { try { reader.cancel(); } catch (e) {} return; }
          return reader.read().then(function (r) {
            if (r.done) { if (buf.trim()) handle(buf.trim()); paint(true); return; }
            buf += dec.decode(r.value, { stream: true });
            var parts = buf.split('\n'); buf = parts.pop();
            parts.forEach(function (l) { if (l.trim()) handle(l.trim()); });
            paint(false);
            return pump();
          });
        }
        return pump();
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (results.length || candidates.length) paint(true); else window.location.href = searchUrl;
      });
    }
    root.pmAsk = function (q) { input.value = q; ask(q); };
    form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
  }


  /* ------------------------------------------------ SKU-safe search (20 Oct 2026)
     Shopify's storefront search no longer matches variant SKUs for a bare query, and a hyphenated part number
     ("UF-524-M") is parsed as NOT-terms. Part-number-looking queries are rewritten to
     "variants.sku:<q> OR <q>" on submit; the echoed query on the results page is cleaned back up. */
  (function () {
    var PART = /^[A-Za-z0-9][A-Za-z0-9.\/-]{1,29}$/;
    function skuQuery(q) {
      q = String(q || '').trim();
      if (!PART.test(q) || !/\d/.test(q) || /^variants\.sku:/i.test(q)) return null;
      return 'variants.sku:' + q + ' OR ' + q;
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action$="/search"]') || f.hasAttribute('data-pm-ai-form')) return;
      var inp = f.querySelector('input[name="q"]');
      if (!inp) return;
      var nq = skuQuery(inp.value);
      if (nq) inp.value = nq;
    }, true);
    var m = /[?&]q=([^&]*)/.exec(window.location.search);
    if (m) {
      var raw = decodeURIComponent(m[1].replace(/\+/g, ' '));
      if (/^variants\.sku:/.test(raw)) {
        var clean = raw.split(' OR ').pop();
        Array.prototype.forEach.call(document.querySelectorAll('input[name="q"]'), function (i) { if (i.value === raw) i.value = clean; });
      }
    }
  })();

  /* ------------------------------------------------ quick order (SKU paste) */
  function parseLines(text) {
    return String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean).map(function (l) {
      var m = l.match(/^(.+?)[\s,;\t]+(\d{1,5})$/);
      return m ? { sku: m[1].trim(), qty: Math.max(1, parseInt(m[2], 10)) } : { sku: l, qty: 1 };
    });
  }
  function searchSku(q) {
    var base = (window.routes && window.routes.search_url) || '/search';
    var url = base + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last&view=pm-sku';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (d) { return d.products || []; });
  }
  // Store search tokenises MPNs on '-', '/', '.', so try raw, quoted and normalised forms and match on the
  // normalised SKU/barcode. Returns [{product, variant}], exact matches first, available first.
  function lookupSku(sku) {
    var want = normalizeMpn(sku);
    // 20 Oct 2026: Shopify's search parser treats "-X" as NOT, so a raw "UF-524-M" finds nothing.
    // The field-scoped form variants.sku:UF-524-M matches exactly; try it first, then the old fallbacks.
    var clean = sku.replace(/["\s]+/g, '');
    var queries = ['variants.sku:' + clean, sku.replace(/-/g, ' '), sku];
    if (want && want !== sku.toUpperCase()) queries.push(want);
    var seen = {}, exact = [], partial = [];
    function collect(products) {
      products.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          if (seen[v.id]) return;
          var n = normalizeMpn(v.sku), bc = normalizeMpn(v.barcode);
          if (n && (n === want || bc === want)) { seen[v.id] = 1; exact.push({ product: p, variant: v }); }
          else if (n && want.length >= 3 && n.indexOf(want) === 0) { seen[v.id] = 1; partial.push({ product: p, variant: v }); }
        });
      });
    }
    var i = 0;
    function step() {
      if (i >= queries.length || exact.length) return Promise.resolve();
      return searchSku(queries[i++]).then(collect).then(step);
    }
    // 20 Oct 2026: hyphen-less input ("15272" for SKU "1527-2") cannot match in Shopify's index, so after the
    // direct queries fail, prefix-search the SKU field on shrinking stems (options[prefix]=last applies to the
    // last term) and let collect() match on the normalised SKU/barcode.
    function stems() {
      var out = [];
      for (var n = want.length - 1; n >= 4 && out.length < 3; n--) out.push('variants.sku:' + want.slice(0, n));
      return out;
    }
    function fallback() {
      if (exact.length || want.length < 5) return Promise.resolve();
      var list = stems(), j = 0;
      function go() {
        if (j >= list.length || exact.length) return Promise.resolve();
        return searchSku(list[j++]).then(collect).then(go);
      }
      return go();
    }
    return step().then(fallback).then(function () {
      var list = exact.length ? exact : partial;
      return list.sort(function (x, y) { return (y.variant.available ? 1 : 0) - (x.variant.available ? 1 : 0); });
    });
  }
  function initQuickOrder(root) {
    var ta = root.querySelector('textarea');
    var resolveBtn = root.querySelector('[data-pm-qo-resolve]');
    var tableWrap = root.querySelector('[data-pm-qo-table]');
    var bar = root.querySelector('[data-pm-qo-bar]');
    var addBtn = root.querySelector('[data-pm-qo-add]');
    var summary = root.querySelector('[data-pm-qo-summary]');
    var live = root.querySelector('[data-pm-qo-live]');
    var max = Number(root.getAttribute('data-max-lines') || 100);
    var rows = [], busy = false;

    function statusHtml(r) {
      switch (r.state) {
        case 'loading': return '<span class="pm-status">Checking…</span>';
        case 'ok': return '<span class="pm-status pm-status--ok">Matched</span>';
        case 'multi': return '<span class="pm-status pm-status--warn">Choose</span>';
        case 'oos': return '<span class="pm-status pm-status--err">Out of stock</span>';
        case 'added': return '<span class="pm-status pm-status--ok">Added</span>';
        case 'failed': return '<span class="pm-status pm-status--err" title="' + esc(r.error || '') + '">Not added</span>';
        case 'error': return '<span class="pm-status pm-status--err">Lookup failed</span>';
        default: return '<span class="pm-status pm-status--err">Not found</span>';
      }
    }
    function productHtml(r, i) {
      if (r.matches.length > 1) {
        return '<select class="pm-select" data-i="' + i + '" aria-label="Choose product for ' + esc(r.sku) + '">' + r.matches.map(function (m, j) {
          return '<option value="' + j + '"' + (j === r.pick ? ' selected' : '') + '>' + esc(m.product.title + (m.variant.title && m.variant.title !== 'Default Title' ? ' — ' + m.variant.title : '') + ' (' + m.variant.sku + ')' + (m.variant.available ? '' : ' — out of stock')) + '</option>';
        }).join('') + '</select>' + (r.error ? '<div class="pm-muted" style="font-size:12px">' + esc(r.error) + '</div>' : '');
      }
      if (r.match) {
        return '<a class="pm-link" href="' + esc(r.match.product.url) + '">' + esc(r.match.product.title) + '</a>' +
          (r.match.variant.title && r.match.variant.title !== 'Default Title' ? '<div class="pm-muted" style="font-size:12px">' + esc(r.match.variant.title) + '</div>' : '') +
          (r.error ? '<div class="pm-muted" style="font-size:12px">' + esc(r.error) + '</div>' : '');
      }
      return '<span class="pm-muted">—</span>';
    }
    function render() {
      if (!rows.length) { tableWrap.hidden = true; bar.hidden = true; return; }
      var focused = document.activeElement && tableWrap.contains(document.activeElement) ? document.activeElement.getAttribute('data-q') : null;
      tableWrap.hidden = false; bar.hidden = false;
      var html = '<table class="pm-table"><thead><tr><th scope="col">Status</th><th scope="col">SKU / MPN</th><th scope="col">Product</th><th scope="col">Price</th><th scope="col">Qty</th><th scope="col"><span class="pm-visually-hidden">Remove</span></th></tr></thead><tbody>';
      rows.forEach(function (r, i) {
        html += '<tr><td>' + statusHtml(r) + '</td><td><code>' + esc(r.sku) + '</code></td><td>' + productHtml(r, i) + '</td><td>' + (r.match ? money(r.match.variant.price) : '') + '</td>' +
          '<td><input class="pm-input" type="number" min="1" max="9999" value="' + r.qty + '" data-q="' + i + '" aria-label="Quantity for ' + esc(r.sku) + '"></td>' +
          '<td><button type="button" class="pm-btn pm-btn--outline pm-btn--sm" data-rm="' + i + '" aria-label="Remove ' + esc(r.sku) + '"' + (busy ? ' disabled' : '') + '>✕</button></td></tr>';
      });
      tableWrap.innerHTML = html + '</tbody></table>';
      if (focused != null) { var el = tableWrap.querySelector('[data-q="' + focused + '"]'); if (el) el.focus(); }
      var ok = rows.filter(ready);
      var units = ok.reduce(function (a, r) { return a + r.qty; }, 0);
      var total = ok.reduce(function (a, r) { return a + r.qty * r.match.variant.price; }, 0);
      summary.textContent = ok.length + ' of ' + rows.length + ' lines ready · ' + units + ' units · ' + money(total);
      addBtn.disabled = busy || !ok.length;
      addBtn.textContent = 'Add ' + ok.length + ' line' + (ok.length === 1 ? '' : 's') + ' to cart';
    }
    function ready(r) { return r.match && r.match.variant.available && r.state !== 'added'; }
    function pick(r, idx) {
      r.pick = idx; r.match = r.matches[idx]; r.error = '';
      r.state = !r.match.variant.available ? 'oos' : (r.matches.length > 1 ? 'multi' : 'ok');
    }
    function announce(msg) { if (live) live.textContent = msg; }
    tableWrap.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('select[data-i]')) { pick(rows[Number(t.getAttribute('data-i'))], Number(t.value)); render(); }
      if (t.matches('input[data-q]')) { rows[Number(t.getAttribute('data-q'))].qty = Math.max(1, parseInt(t.value, 10) || 1); render(); }
    });
    tableWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rm]');
      if (b && !busy) { rows.splice(Number(b.getAttribute('data-rm')), 1); render(); }
    });
    resolveBtn.addEventListener('click', function () {
      var parsed = parseLines(ta.value);
      if (!parsed.length) { toast('Paste at least one SKU or MPN'); ta.focus(); return; }
      if (parsed.length > max) { toast('Please limit to ' + max + ' lines per batch'); return; }
      rows = parsed.map(function (p) { return { sku: p.sku, qty: p.qty, state: 'loading', matches: [], match: null, pick: 0, error: '' }; });
      var queue = rows.slice(), active = 0, CONC = 4, done = 0;
      busy = true; resolveBtn.disabled = true; render();
      function next() {
        if (!queue.length) {
          if (!active) {
            busy = false; resolveBtn.disabled = false; render();
            announce(rows.filter(ready).length + ' of ' + rows.length + ' lines matched');
          }
          return;
        }
        var r = queue.shift(); active++;
        lookupSku(r.sku).then(function (m) {
          r.matches = m;
          if (!m.length) r.state = 'none';
          else pick(r, 0); // list is sorted available-first
        }).catch(function () { r.state = 'error'; }).then(function () {
          active--; done++;
          if (done % 5 === 0 || !queue.length) render();
          next();
        });
      }
      for (var k = 0; k < CONC; k++) next();
    });
    addBtn.addEventListener('click', function () {
      var todo = rows.filter(ready);
      if (!todo.length) return;
      busy = true; render();
      var added = 0, failed = 0;
      function addOne(r) {
        return addToCart([{ id: r.match.variant.id, quantity: r.qty }], addBtn, 'PmQuickOrder', { quiet: true })
          .then(function () { r.state = 'added'; added++; })
          .catch(function (err) { r.state = 'failed'; r.error = err.message; failed++; });
      }
      var chunks = [];
      for (var c = 0; c < todo.length; c += 50) chunks.push(todo.slice(c, c + 50));
      chunks.reduce(function (p, chunk) {
        return p.then(function () {
          return addToCart(chunk.map(function (r) { return { id: r.match.variant.id, quantity: r.qty }; }), addBtn, 'PmQuickOrder', { quiet: true })
            .then(function () { chunk.forEach(function (r) { r.state = 'added'; }); added += chunk.length; })
            // Shopify rejects the whole batch when one line fails: retry this chunk line by line.
            .catch(function () { return chunk.reduce(function (q, r) { return q.then(function () { return addOne(r); }); }, Promise.resolve()); });
        });
      }, Promise.resolve()).then(function () {
        busy = false; render();
        var msg = added + ' line' + (added === 1 ? '' : 's') + ' added to cart' + (failed ? ' · ' + failed + ' not added (see table)' : '');
        toast(msg); announce(msg);
        if (added) openCartAfterAdd(addBtn);
      });
    });
  }

  /* ------------------------------------------------------- brands filter */
  function initBrandFilter(root) {
    var input = root.querySelector('[data-pm-brand-filter]');
    if (!input) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      $all('[data-pm-brand]', root).forEach(function (li) { li.hidden = q && li.getAttribute('data-pm-brand').indexOf(q) === -1; });
      $all('[data-pm-brand-group]', root).forEach(function (g) { g.hidden = !g.querySelector('[data-pm-brand]:not([hidden])'); });
    });
  }

  /* ------------------------------ PDP spec strip follows the selected variant */
  function updateSpecStrips(variantId) {
    if (!variantId) return;
    $all('[data-pm-spec]').forEach(function (strip) {
      var dataEl = document.querySelector('script[data-pm-spec-variants="' + strip.getAttribute('data-product-id') + '"]');
      if (!dataEl) return;
      var map; try { map = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var v = map[String(variantId)];
      if (!v) return;
      var pack = (v.pack || '').split('|');
      var vals = { sku: v.sku || '', qty: pack[0] || '', uom: pack[1] || '' };
      Object.keys(vals).forEach(function (k) {
        var cell = strip.querySelector('[data-pm-spec-cell="' + k + '"]');
        if (!cell) return;
        cell.hidden = !vals[k];
        cell.querySelector('[data-pm-spec-value]').textContent = vals[k];
      });
    });
  }
  function currentVariantId() {
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }
  function watchVariants() {
    if (!document.querySelector('[data-pm-spec]')) return;
    var handler = function (e) {
      var d = (e && (e.detail || e)) || {};
      var id = (d.variant && d.variant.id) || (d.data && d.data.variant && d.data.variant.id) || d.variantId || null;
      setTimeout(function () { updateSpecStrips(id || currentVariantId()); }, 0);
    };
    document.addEventListener('product:variant-change', handler);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.productVariantChange, handler);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form, product-form')) setTimeout(function () { handler({}); }, 600);
    });
    updateSpecStrips(currentVariantId());
  }

  /* --------------------------------------------------------------- boot */
  function boot() {
    paintAllCutoffs();
    setInterval(paintAllCutoffs, 30000);
    watchMiniCart();
    watchVariants();
    initPlaceholders();
    initSearchForms();
    $all('[data-pm-ai]').forEach(initConcierge);
    $all('[data-pm-quick-order]').forEach(initQuickOrder);
    $all('[data-pm-brands]').forEach(initBrandFilter);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target;
      paintAllCutoffs();
      $all('[data-pm-ai]', s).forEach(initConcierge);
      $all('[data-pm-quick-order]', s).forEach(initQuickOrder);
      $all('[data-pm-brands]', s).forEach(initBrandFilter);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
